import React, { createContext, useReducer, useEffect } from 'react';
import { projectReducer } from '../projectReducer';
import uuid from 'uuid/v1';

export const ProjectContext = createContext();

export const ProjectContextProvider = (props) => {
    const [projects, dispatch] = useReducer(projectReducer, [], () => {
        const localStore = localStorage.getItem('projects');
        return localStore ? JSON.parse(localStore) : [{ 
            id: uuid(), 
            createdOn: new Date(), 
            name: 'Sock', 
            section: 'Gusset', 
            needle: '10', 
            stitchName: 'Fisherman', 
            rowCount: 0, 
            stitchCount: 0, 
            yarn: 'Wool ease', 
            notes: 'repeat decrease for two rows'
        }];
    });

    useEffect(() => {
        localStorage.setItem('projects', JSON.stringify(projects))
    }, [projects]);

    return (
        <ProjectContext.Provider value = {{projects, dispatch}}>
            {props.children}
        </ProjectContext.Provider>
    )
}
